module.exports = __webpack_public_path__ + "img/UI_common_framelabelWF_02_77bcbbad9.png";